import React from 'react';
import Confetti from 'react-confetti'; // Import Confetti
import ReactDOM from 'react-dom';
import { useNavigate } from 'react-router-dom';
import BouncingImage from './BouncingImage';

const TutorialModal = ({ unlockedItem, description, showTutorialModal, link }) => {
  if (!unlockedItem) {
    unlockedItem = 'Example Feature';
  }
  if (!description) {
    description = "You'll now be able to do SOMETHING you couldn't do before!";
  }
  if (!showTutorialModal) {
    showTutorialModal = true;
  }
  const navigate = useNavigate();

  const handleNavigation = () => {
    // Navigate to a different route (e.g., "/job-board")
    showTutorialModal = false;
    console.log(link);
    navigate(link);
  };

  if (showTutorialModal) {
    return ReactDOM.createPortal(
      <div className="fixed inset-0 z-70 overflow-y-auto">
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1000,
            pointerEvents: 'none',
          }}
        >
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            recycle={false}
            numberOfPieces={200}
            gravity={0.3}
          />
        </div>
        <div className="flex min-h-full items-center justify-center p-4">
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/70 transition-opacity"></div>

          {/* Modal */}
          <div className="relative p-4 rounded-lg w-full max-w-4xl flex items-center justify-center z-10">
            <BouncingImage imageLink={'/thinkingcar.png'} />
            <div className="">
              <p className="text-white text-4xl ">
                You've unlocked <br />
                <strong>{unlockedItem}</strong>!
              </p>
              <p className="text-white text-2xl">
                <br />
                {description}
              </p>
              <button
                onClick={handleNavigation}
                type="button"
                className="mt-7 py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
              >
                Let's go!
                <svg
                  className="shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>,
      document.getElementById('modal-root') || document.body
    );
  }
};

export default TutorialModal;
